import React, { useState } from 'react';
import OxygenOTPComponent from '../components/OxygenOTPComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useCustomAlert from "../components/Alert2";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';
import { setOtpLoading } from '../redux/features/oxygen/oxygenRetailSlice';
import { setShowModal } from '../redux/features/oxygen/customModalSlice';
import { sendAODF2OTP, validateAODF2OTP } from '../services/oxygenRetailServices';


const AODF2FormOTP = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const [loading, setLoading] = useState(false);
    const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData?.precustomer);
    
    const handleResendOTP = async() =>{
      const payload = {
        msisdn: String(storePrecustomer?.msisdn),
        nin: String(storePrecustomer?.nin),
      }
      const res = await sendAODF2OTP(payload);
      console.log("res", res);
        
      if(res.status === true) {
        customAlert.showToast("success", `${res?.message}` ||"OTP sent successfully, please check your phone for OTP"); 
      } else {
        customAlert.showToast("error", `${res?.message}` || "Failed to send OTP");
      }
    }
      
      const handleProceed = async(otp) =>{
        dispatch(setOtpLoading(true));
        const payload = {
          otp: String(otp),
          msisdn: String(storePrecustomer?.msisdn)
        }
        const res = await validateAODF2OTP(payload);
        console.log("res", res);
        
        if(res.status === true) {
          // Update precustomer
          dispatch(
            updatePrecustomer({
              ...storePrecustomer,
              onboarding_status: "oxygen-device-bundles",
            })
          );

          await updateCustomerOnboardingStat(
            storePrecustomer?.msisdn,
            "OTP_VALIDATED"
          );

          customAlert.showToast("success", `${res?.message}`||"OTP validated successfully");
          
          navigate("/oxygen-device-bundles"); 
          
        }else{
          customAlert.showToast("error", `${res?.message}` || "Failed to validate OTP");
        }
        dispatch(setOtpLoading(false));
    }

    const actions = {handleResendOTP:handleResendOTP , handleProceed:handleProceed, consentText:"Enter OTP to Consent To the Provided Details for Retail customers (AODF2)"};


  return (
    <div>
        <OxygenOTPComponent {...actions}  />
    </div>
  )
}

export default AODF2FormOTP;